import { call, put, takeEvery } from 'redux-saga/effects';

import {
    FETCH_WELLNESS_DAILY_PULSE_OX_DATA,
    FETCH_WELLNESS_DAILY_PULSE_OX_DATA_FETCHING,
    FETCH_WELLNESS_DAILY_PULSE_OX_DATA_SUCCESS,
    FETCH_WELLNESS_DAILY_PULSE_OX_DATA_FAIL
} from '../actions/ActionTypes';
import { gcApi } from '../config/axios';

// Workers
export function* fetchDailyPulseOxSaga(action) {
    const { displayName, calendarDate } = action;

    try {
        yield put({
            type: FETCH_WELLNESS_DAILY_PULSE_OX_DATA_FETCHING
        });

        const response = yield call(gcApi.get, `/wellness-service/wellness/daily/spo2acclimation/${calendarDate}`);

        yield put({
            type: FETCH_WELLNESS_DAILY_PULSE_OX_DATA_SUCCESS,
            calendarDate: calendarDate,
            displayName: displayName,
            dailyPulseOxData: response.data
        });
    } catch (e) {
        yield put({
            type: FETCH_WELLNESS_DAILY_PULSE_OX_DATA_FAIL,
            calendarDate: calendarDate,
            displayName: displayName,
            dailyPulseOxData: null
        });
    }
}

// Watchers
export const dailyPulseOxSagas = [takeEvery(FETCH_WELLNESS_DAILY_PULSE_OX_DATA, fetchDailyPulseOxSaga)];
